import React, { useState, useEffect } from "react";
import utils from "@utils";
import PropTypes from "prop-types";
import { NON_RK_PAY_INVOICE_STATUS_V4 } from "@constants";
import { PaymentService } from "@services";
import { Modal, ScrollDetect } from "../../../../../components";

import "./AddInvoice.scss";
import "../../PaymentSummaryV2.scss";

const AddInvoice = ({ show, onCancel, clientId, push, invoiceIds, user, method, clientName }) => {
	const { lang } = global;
	const [invoiceList, setInvoiceList] = useState([]);
	const [selectedValues, setSelectedValues] = useState([]);
	const [hasMoreRecords, setHasMoreRecords] = useState(false);
	const [pageNumber, setPageNumber] = useState(1);

	const getInvoices = async () => {
		const setInvoiceIdsFromOtherPage = (invoiceCommingFromOtherPage) => {
			if (invoiceCommingFromOtherPage.length > 0) {
				const invoiceIdsSplited = invoiceCommingFromOtherPage.split(",");
				if (!selectedValues.includes(invoiceIdsSplited)) {
					setSelectedValues(...selectedValues, invoiceIdsSplited);
				}
			}
		}

		const queryParams = {
			displayCount: 15,
			pageNumber,
			archived: false,
			clientId,
			sortBy: "StartDateTime",
			asc: true,
			pendingOfficerSubmission: false,
			vehicleInvoicingRequired: false,
			onlyVoided: false,
			statusIds: [
				NON_RK_PAY_INVOICE_STATUS_V4.CREATED,
				NON_RK_PAY_INVOICE_STATUS_V4.PENDING_AGENCY_REVIEW,
			],
			isEstimate: false,
			pendingJobs: "",
		};

		if(clientId !== 0) {
			const {
				data: { ItemList, Count },
			} = await PaymentService.getNonRKPayInvoicesV4(() => {}, queryParams);

			const formattedItemList = ItemList.map(item => ({
				Id: item.Id,
				Checked: invoiceIds.includes(item.Id),
				CreationDate: item.CreationDate,
				InvoiceNumber: item.InvoiceNumber,
			}));

			if (pageNumber === 1) {
				setInvoiceIdsFromOtherPage(invoiceIds);
				setInvoiceList(formattedItemList);
				setHasMoreRecords(Count > formattedItemList.length);
			} else {
				const newRecords = [...invoiceList, ...formattedItemList];
				const itemsToAdd = ItemList.filter(item => selectedValues.includes(item.Id)).map(x => x.Id);
				setSelectedValues((prevState) => [...prevState, ...itemsToAdd]);
				setInvoiceList(newRecords);
				setHasMoreRecords(Count > newRecords.length);
			}
		}

	};


	useEffect(() => {
		getInvoices();
	}, [clientId, pageNumber]);

	const buildNewUrl = () => {
		const invoiceIdsSelected = Object.values(selectedValues);
		onCancel();
		push({
			pathname: "/payments/invoices-summary",
			query: { invoiceIds: invoiceIdsSelected.join(","), method },
		});
	};

	const onSelectInvoice = e => {
		const { value } = e.target;
		if (e.target.checked) {
			setSelectedValues([...selectedValues, value]);
		} else {
			setSelectedValues(selectedValues.filter(id => id !== value));
		}

		const updatedInvoiceList = invoiceList.map(invoice => {
			if (invoice.Id.toString() === value) {
				return { ...invoice, Checked: e.target.checked };
			}
			return invoice;
		});
		setInvoiceList(updatedInvoiceList);
	};

	const loadNextPage = () => {
		setPageNumber(prevState => prevState + 1);
	};

	return (
		<Modal
			show={show}
			onHide={onCancel}
			id="payment-summary-v2"
		>
			<Modal.Header closeButton>
				<Modal.Title>{lang.t("Add Invoice")}</Modal.Title>
			</Modal.Header>
			<Modal.Body id="modal-body-add-invoice">
				<div className="row invoice-columns">
					<div className="col-sm-6 col-md-7 ball-mart-container">
						<p className="font-semi-bold">{lang.t(clientName)}</p>
					</div>
				</div>
				<div className="table-container">
					<div className="row invoice-columns">
						<div className="col-sm-1 col-md-1">
							<span className="font-semi-bold" />
						</div>
						<div className="col-sm-3 col-md-3">
							<span className="font-semi-bold">{lang.t("Invoice")} #</span>
						</div>
						<div className="col-sm-3 col-md-3">
							<span className="font-semi-bold">{lang.t("Created Date")}</span>
						</div>
					</div>
					<div className="invoice-columns-body">
						{invoiceList.length > 0 &&
							invoiceList.map(invoice => (
								<div className="row">
									<div className="col-sm-1 col-md-1">
										<input
											type="checkbox"
											value={invoice.Id}
											onChange={onSelectInvoice}
											checked={invoice.Checked}
										/>
									</div>
									<div className="col-sm-3 col-md-3">{invoice.InvoiceNumber}</div>
									<div className="col-sm-3 col-md-3">
										{utils.formatDate(
											invoice.CreationDate,
											"en-US",
											user.TimeZoneId,
											"numeric",
										)}
									</div>
								</div>
							))}
					</div>
					<If condition={hasMoreRecords}>
						<ScrollDetect
							className="text-center no-overflow"
							onVisible={() => loadNextPage()}
						>
						<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
						</ScrollDetect>
					</If>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					type="button"
					className="btn btn-primary"
					onClick={buildNewUrl}
					disabled={!selectedValues.length}
				>
					{lang.t("Add to Summary")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

AddInvoice.propTypes = {
	show: PropTypes.bool,
	onCancel: PropTypes.func,
	clientId: PropTypes.number,
	push: PropTypes.object.isRequired,
	invoiceIds: PropTypes.array,
	user: PropTypes.object,
	method: PropTypes.string.isRequired,
	clientName: PropTypes.string,
};

AddInvoice.defaultProps = {
	show: false,
	onCancel: () => {},
	clientId: 0,
	invoiceIds: [],
	user: {},
	clientName: "",
};

export default AddInvoice;
